import { useThemeColors } from "../hooks/useThemeColors";

export default function LoadingSpinner({ size = "normal", className = "" }) {
  const { themeColor, palette } = useThemeColors();

  const sizeClasses = {
    small: "h-6 w-6",
    normal: "h-8 w-8",
    large: "h-12 w-12",
  };

  const borderWidthClasses = {
    small: "border-2",
    normal: "border-3",
    large: "border-4",
  };

  // Use theme colors if available, otherwise fall back to blue
  const getSpinnerColor = () => {
    if (themeColor) {
      return themeColor;
    }
    return "#3b82f6";
  };

  return (
    <div className={`flex justify-center items-center py-12 ${className}`}>
      <div className="relative">
        {/* Normal ring with gradient border */}
        <div
          className={`${sizeClasses[size]} rounded-full ${borderWidthClasses[size]} border-gray-200 animate-spin`}
          style={{
            borderTopColor: getSpinnerColor(),
            borderRightColor: getSpinnerColor(),
            animation: "spin 1s linear infinite",
          }}
        ></div>
      </div>
    </div>
  );
}
